export const addEvent = function (cat, action, label) {
    var type = typeof _gaq;
    if (type != "undefined") {
        _gaq.push(['_trackEvent', cat, action, label]);
    }
};
export const addPageView = function (url) {
    var type = typeof _gaq;
    if (type != "undefined") {
        _gaq.push(['_trackPageview', url]);
    }
};


window.coworkGa = function(category, action, label){
    addEvent(category, action, label);
}

$("#quikrLogo").on('click', function() {
	let pageType = 'SnBpage'
    if(globals.pageType == 'CoworkVAP') {
        pageType = 'VAP';
    } 
    if(globals.pageType == 'CoworkHome') {
        pageType = 'Homepage';
    }
    addEvent('QH_CoWork', pageType+'_CoWork_Header', 'QH_CoWork_'+pageType+'_Header_Logo-Click');
});

$("#postAdBtn").on('click', function() {
	let pageType = 'SnBpage'
    if(globals.pageType == 'CoworkVAP') {
        pageType = 'VAP';
    } 
    if(globals.pageType == 'CoworkHome') {
        pageType = 'Homepage';
    }
    addEvent('QH_CoWork', pageType+'_CoWork_Header', 'QH_CoWork_'+pageType+'_Header_Postad-Click');
});

$("#coworksearch").on('click', function() {
	let pageType = 'SnBpage'
    if(globals.pageType == 'CoworkVAP') {
        pageType = 'VAP';
    } 
    if(globals.pageType == 'CoworkHome') {
        pageType = 'Homepage';
    }
    let text = $("#coworksearch").val();
    addEvent('QH_CoWork', pageType+'_CoWork_Header', 'QH_CoWork_'+pageType+'_Header_Search-click_'+text);
});

